module.exports = __webpack_public_path__ + "img/importing.257a8ad3.svg";